<template>
	<div
		class="flex flex-col fixed w-[100vw] h-[100vh] top-0 left-0 z-40 bg-dj-light-blue px-3 py-4 overflow-y-auto transition duration-600 ease-out transform:ease-in"
		:style="{ transform: 'translateX(' + offset + 'vw)' }"
	>
		<BaseLink @click="closeAll()" type="grey" class="cursor-pointer absolute top-[10px] right-[16px]">
			<span class="material-icons-outlined font-medium text-3xl">close</span>
		</BaseLink>

		<slot></slot>
	</div>
</template>

<script lang="ts">
import { ref, computed, defineComponent } from "vue";
import BaseLink from "~/ui-kit/components/BaseLink.vue";

export default defineComponent({
	name: "BaseMobileNav",
	components: { BaseLink },
	props: {
		openItem: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { emit }) {
		const offset = computed(() => {
			return props.openItem ? "0" : "100";
		});

		function closeAll() {
			emit("closeAll");
		}

		return {
			offset,
			closeAll,
		};
	},
});
</script>
